module.exports = __webpack_public_path__ + "static/media/sound-white.adb3a896.svg";